import { IAction } from "../model/IAction";

export const UPDATE_CANCELLATION_DISABLED = "UPDATE_CANCELLATION_DISABLED";
export function updateCancellationDisabled(newValue: boolean): UpdateCancellationDisabledAction {
  console.log("new value for cancellation disabled", newValue);
  return {
    type: UPDATE_CANCELLATION_DISABLED,
    updatedValue: newValue
  };
}
export interface UpdateCancellationDisabledAction extends IAction {
    updatedValue: boolean;
}
